import React, { useState, useMemo } from "react";
import { Box, alpha, Typography } from "@mui/material";
import CustomDialog from "./Dialog";
import { ReactComponent as FailedIcon } from "../../assets/icons/notif-fail.svg";
import { config } from "../../config";

function HintDialog({ open, setClose }) {
  const handleClose = (event, reason) => {
    // if (reason === "backdropClick") {
    //   return;
    // }
    setClose();
    window.location.href = config.DELYSIUM_ONE_CLIENT_URL;
  };

  return (
    <CustomDialog
      hasCloseButton={true}
      BackdropProps={{
        sx: {
          backgroundColor: (theme) => alpha(theme.palette.background.default, 0.7)
        }
      }}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 135, 54, 0.1)",
          width: "80%"
        }
      }}
      setClose={handleClose}
      open={open}>
      <Box sx={{}}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}>
          <FailedIcon />
          <Typography variant="h5" sx={{ ml: "10px", color: "rgba(202, 63, 100, 1)" }}>
            Hint
          </Typography>
        </Box>
        <Box
          sx={{
            mt: "8px",
            fontSize: "12px",
            lineHeight: "18px",
            fontFamily: "Poppins",
            color: "#fff"
          }}>
          Sorry, dashboard is currently not supported on mobile. Please operate on PC.
        </Box>
      </Box>
    </CustomDialog>
  );
}

export default HintDialog;
